module.exports = __webpack_public_path__ + "static/media/logo-small.b77ed046.svg";